import { formatDecimal, formatNumber, type ExternalCatalogFood, type Food } from '@jungles/shared';
import type { ScanPrefill } from '../screens/FoodForm';

export type SearchFood = (Food & { external?: boolean }) | ExternalCatalogFood;
export interface FoodSearchResponse {
  recent: Food[];
  catalog: SearchFood[];
  external: SearchFood[];
  externalError: string | null;
  hasMore?: {recent: boolean; catalog: boolean};
}

// Presentation only: keep the source brand intact in DTOs and saved food values.
export function displayFoodBrand(brand: string | null): string {
  return (brand ?? '').replace(/ \(неофициальный архив\)$/, '');
}

export function unifiedFoods(data: FoodSearchResponse): SearchFood[] {
  const seen = new Set<string>();
  return [...data.recent, ...data.catalog, ...(data.external ?? [])].filter(food => {
    if (seen.has(food.id)) return false;
    seen.add(food.id);
    return true;
  });
}

// defaultGrams is the API's existing servingGrams metadata, not package volume.
export function foodPortionGrams(food: Pick<Food, 'defaultGrams' | 'servingGrams'>): number | null {
  const grams = food.servingGrams ?? food.defaultGrams;
  return typeof grams === 'number' && Number.isFinite(grams) && grams > 0 ? grams : null;
}

export function foodSelection(food: SearchFood) {
  const values = { name: food.name, brand: food.brand, barcode: food.barcode,
    kcal: food.kcal100, protein: food.p100, fat: food.f100, carbs: food.c100,
    basis: 'per100' as const };
  const prefill: ScanPrefill = { ...values, foodId: food.id, grams: foodPortionGrams(food) ?? 100, source: 'barcode', barcodeOrigin: 'lookup', nutritionBasis: food.nutritionBasis, ...(food.external ? {notes:'Источник: Open Food Facts. Проверьте значения на упаковке и заполните недостающие поля перед сохранением.'} : {}) };
  return { entry: { foodId: food.id }, prefill };
}

export function foodNutritionLabel(food: SearchFood): string {
  const number = (v: number | null, whole = false) => v === null ? '—' : whole ? formatNumber(v) : formatDecimal(v);
  return `${food.nutritionBasis === 'per100ml' ? 'на 100 мл' : food.nutritionBasis === 'off_100g_physical_basis_unverified' ? 'КБЖУ' : 'на 100 г'} · ${number(food.kcal100,true)} ккал · Б ${number(food.p100)} Ж ${number(food.f100)} У ${number(food.c100)}`;
}
